import React, { useState } from 'react';
import Modal from '@rd-web-markets/shared/dist/util/Modal';
import { useTranslation } from 'react-i18next';
import { DatePicker } from '@rd-web-markets/shared/dist/util/date';
import { useEffect } from 'react';
const FirstFastCheckDateEditModal = _ref => {
  let {
    onHide,
    show,
    project,
    createSubmitStatus
  } = _ref;
  const {
    t
  } = useTranslation();
  const [selectedDate, setSelectedDate] = useState(project.first_fast_check.lifetime_of_the_customer_project_to);
  const [isDateChanged, setIsDateChanged] = useState(false);
  useEffect(() => {
    if (selectedDate !== project.first_fast_check.lifetime_of_the_customer_project_to) {
      setIsDateChanged(true);
    } else {
      setIsDateChanged(false);
    }
  }, [selectedDate, project.first_fast_check.lifetime_of_the_customer_project_to]);
  const submit = async () => {
    await createSubmitStatus({
      id: project.first_fast_check.id,
      first_fast_check: {
        lifetime_of_the_customer_project_to: selectedDate
      }
    });
  };
  const title = /*#__PURE__*/React.createElement("div", {
    style: {
      color: 'white'
    }
  }, t('date_change_for_project') + ': ' + project.project_name);
  const body = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "text-danger"
  }, t('decreasing_the_date_may_remove_project_data_certain_financial_periods')), /*#__PURE__*/React.createElement(DatePicker, {
    onChange: date => setSelectedDate(date),
    selected: selectedDate
  }), isDateChanged && /*#__PURE__*/React.createElement("p", {
    className: "text-warning"
  }, "".concat(t('date_is_changed_from'), ": ").concat(project.first_fast_check.lifetime_of_the_customer_project_to, " > ").concat(selectedDate, " ")));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    size: "md",
    show: show,
    title: title,
    renderBody: () => body,
    onHide: onHide,
    onSubmit: () => submit(),
    disabled: !isDateChanged
  }));
};
export default FirstFastCheckDateEditModal;